import { Component } from '@angular/core';
import {OrderService} from "../../shared/services/order.service";
import {NotificationService} from "../../shared/services/notification.service";
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'mbnm-contact-order',
  templateUrl: './contact-order.component.html',
  styleUrls: ['./contact-order.component.scss']
})
export class ContactOrderComponent {
  contact = {
    reason: '',
    comments: ''
  };

  order;

  constructor(
    private orderService: OrderService,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<ContactOrderComponent>
  ) { }

  public async sendMessage() {
    const messageObj = {
      Reason: this.contact.reason,
      Comments: this.contact.comments
    };
    if (!this.contact.reason && (this.order.Status === 'SHIPPED' || this.order.Status === 'DELIVERED')) {
      this.notificationService.createNotification('Please select a reason.', 'warn');
    } else if (!this.contact.comments) {
      this.notificationService.createNotification('Please enter a message.', 'warn');
    } else {
      try {
        await this.orderService.sendOrderMessage(this.order.ConfirmationCode, messageObj);
        this.notificationService.createNotification('Message successfully sent!', 'success');
        this.dialogRef.close();
      } catch (error) {
        this.notificationService.createNotification('There was an error sending the message', 'error');
      }
    }
  }
}
